const __WEBPACK_NAMESPACE_OBJECT__ = ((flarum.extensions['flamarkt-core']||{})['forum']||{})['pages/ProductIndexPage'];